import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { faqs } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section aria-labelledby="faq" className="border-y-2 border-coral/30 bg-carbon-soft" data-id="element-40" data-mp="1nv1l2blse3ze">
      <div className="mx-auto max-w-3xl px-3 py-6 sm:px-6 sm:py-7" data-id="element-41" data-mp="2bmgrafgop5fx">
        <Reveal className="text-center" data-id="element-42" data-mp="2fknvybxvigar">
          <h2 id="faq" className="font-display text-2xl uppercase leading-none tracking-wide text-cream sm:text-4xl" data-id="element-43" data-mp="2fns5zpy0s69c">
            Preguntas frecuentes
          </h2>
          <span aria-hidden="true" className="mx-auto mt-1.5 block h-1 w-14 rounded-full bg-coral" data-id="element-44" data-mp="26rav8ntkiae4" />
        </Reveal>

        <div className="mt-3 grid gap-1.5" data-id="element-45" data-mp="2zazvojwm4y2q">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={faq.q} className="rounded-lg border border-nude/20 bg-carbon" data-id="element-46" data-mp="1vnetgl53eg9v" data-mpi={i}>
                <h3 data-id="element-47" data-mp="25fuczmw1fcwv">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-panel-${i}`} className="flex w-full items-center justify-between gap-3 px-3 py-2.5 text-left sm:px-4" data-id="element-48" data-mp="25gcht7wrmzge">
                    <span className="text-[0.8rem] font-bold text-cream sm:text-sm" data-id="element-49" data-mp="2oe6o3e6iewv3">
                      {faq.q}
                    </span>
                    <ChevronDownIcon size={17} className={`flex-shrink-0 text-coral transition-transform duration-200 ease-soft ${isOpen ? 'rotate-180' : ''}`} data-id="element-50" data-mp="2jgn92c1zmg23" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-51" data-mp="2p5ese3t815ls">
                  {isOpen && <motion.div id={`faq-panel-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: EASE
              }} className="overflow-hidden" data-id="element-52" data-mp="2u36xjzivmo7x">
                      <p className="px-3 pb-2.5 text-[0.78rem] leading-snug text-beige sm:px-4 sm:text-sm" data-id="element-53" data-mp="3d084vqzwl0f1">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}